import { DataLayer } from '@grandvisionhq/analytics';

const eventName = 'size guide';
const eventAction = 'click';
const pushSizeGuideLinkClickEvent = (sku, name)=>{
    DataLayer.pushEvent({
        event: eventName,
        eventAction,
        eventLabel: `open - ${sku} - ${name}`
    });
};
const pushBookAppointmentClickEvent = (sku, name)=>{
    DataLayer.pushEvent({
        event: eventName,
        eventAction,
        eventLabel: `book an appointment - ${sku} - ${name}`
    });
};
const pushVTOClickEvent = (sku, name)=>{
    DataLayer.pushEvent({
        event: eventName,
        eventAction,
        eventLabel: `try on you - ${sku} - ${name}`
    });
};

export { pushBookAppointmentClickEvent, pushSizeGuideLinkClickEvent, pushVTOClickEvent };
//# sourceMappingURL=SizeGuideEvents.js.map
